import Button from 'components/form/Button';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { icons, membershipType } from 'utils/constants';
import {
  getDataFromLocalStorage,
  getUserType,
  objectToFormData,
} from 'utils/helpers';
import VerifyModel from './VerifyModel';
import { useDispatch } from 'react-redux';
import { handelSpeakerEmailVerify, showSuccess } from 'store/slices';
import DashboardJoinEvents from '../DashboardJoinEvents';
import ProfileCompletion from './ProfileCompletion';

const perks = [
  {
    id: 1,
    name: 'Learn',
    icons: icons?.NewBook,
  },
  {
    id: 2,
    name: 'Present',
    icons: icons?.NewComputer,
  },
  {
    id: 1,
    name: 'Publish',
    icons: icons?.NewPresentation,
  },
  {
    id: 1,
    name: 'Network',
    icons: icons?.NewPeople,
  },
  {
    id: 1,
    name: 'Mentor',
    icons: icons?.Newlocal_library,
  },
  {
    id: 1,
    name: 'Jobs',
    icons: icons?.NewBuildings,
  },
];

const Welcome = ({ researchProfileCount = 50 }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [showEmailModel, setShowEmailModel] = useState(false);
  let { first_name, last_name, user_type, name, email_id } =
    getDataFromLocalStorage();

  const findType = membershipType.find((o) => o.id === user_type)?.type;

  const handleRedirect = (blockType) => {
    const userType = getUserType();
    const blockRoute = {
      Learn: `/${userType}/digital-library`,
      Present: `/${userType}/conferences-and-events`,
      Publish: `/${userType}/publications`,
      Network: `/${userType}/network-management/network`,
      Mentor: `/${userType}/mentorship/mentee/all-mentors`,
      Jobs: `/${userType}/career-support`,
    };
    navigate(blockRoute[blockType]);
  };

  const getVerifiyedEmail = async () => {
    const response = await dispatch(
      handelSpeakerEmailVerify(objectToFormData({ email: email_id }))
    );
    // setModalShow(false);
    if (response?.status === 200) {
      // const response = await dispatch(fetchUserDetails());
      dispatch(showSuccess(response.message));
      setModalShow(false);
    }
  };

  return (
    <>
      <div className="cpt-30 cpb-40 cps-24 cpe-21 d-flex flex-wrap h-100">
        <div className="d-flex justify-content-center flex-column">
          <div className="d-flex align-items-center gap-2 cmb-21">
            <div className="font-poppins text-20-400-25 color-title-navy">
              Hello, {name ? `${name}` : `${first_name} ${last_name}`} !
            </div>
            <DashboardJoinEvents
              onClick={() => {
                navigate(`/${findType}/dashboard/live-events`);
              }}
            />
          </div>

          <ProfileCompletion researchProfileCount={researchProfileCount} />

          <div className="text-14-300-24 color-1717 cmb-14">
            Unlock Membership Perks, Research Insights, and Global Connections :
          </div>
          <div className="d-flex align-items-center gap-3 w-100 flex-wrap">
            {perks.map((o) => {
              return (
                <div
                  className="perks-block"
                  key={o?.id}
                  onClick={() => {
                    handleRedirect(o?.name);
                  }}
                >
                  <img src={o?.icons} alt="book" />
                  <span className="text-16-500-20">{o?.name}</span>
                </div>
              );
            })}
          </div>
        </div>
        <VerifyModel
          showEmailModel={showEmailModel}
          modalShow={modalShow}
          setModalShow={setModalShow}
          // onHide={() => setModalShow(false)}
          VerifyEmail={() => getVerifiyedEmail()}
        />
      </div>
    </>
  );
};
export default Welcome;
